// extracted by mini-css-extract-plugin
module.exports = {"CheckboxBadgeWrapper":"CheckboxBadge_CheckboxBadgeWrapper__2UIob","CheckboxBadge":"CheckboxBadge_CheckboxBadge__1Kt2A"};